export function timeOut(status) {
    if(status === 401) {
      if(sessionStorage.getItem('userToken')) { 
        sessionStorage.removeItem('userToken');
      }
      if(localStorage.getItem('userToken')) { 
        localStorage.removeItem('userToken');
      }
      window.location.reload();
    }
    else{
      return ;
    }
}

export function objectMerge(object, source){
  for (var key in source) {
    if (source.hasOwnProperty(key)) object[key] = source[key];
  }
  return object;
}